import { all, take, put } from "redux-saga/effects";
import { SET_FLAG, ROUTER_CACHE_RESTORED } from "../CONSTANTS";

export default function* restoreFromCache() {
  yield all([take(ROUTER_CACHE_RESTORED)]);
  yield put({ type: SET_FLAG, payload: { key: "cacheRestored", value: true } });
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/saga/restoreFromCache.js